import Swal from "sweetalert2";
import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import config from "../config";
import { fiscalMonthOrder, isQuarterlyFillDate, sortByYearMonth } from '../js/global';
import { NumericFormat } from 'react-number-format';

function SepticTable({ onSendData }) {
    const { id, years, fac_id } = useParams();
    const [isDisabled, setIsDisabled] = useState(true);
    const [groupedData, setGroupedData] = useState([]);
    const [inputValues, setInputValues] = useState({});
    const [workingDays, setWorkingDays] = useState([]);

    function getCalendarDays(year, isBuddhistEra = false) {
        // ถ้าเป็นปีพุทธศักราช ให้แปลงเป็นคริสต์ศักราชก่อน
        const christianYear = isBuddhistEra ? year - 543 : year;

        // ตรวจสอบว่าเป็นปีอธิกสุรทินหรือไม่
        const isLeapYear = (christianYear % 4 === 0 && christianYear % 100 !== 0) || christianYear % 400 === 0;
        
        // สร้าง array จำนวนวันในแต่ละเดือน
        const calendarDays = [31, isLeapYear ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        
        return calendarDays;
    }
    
    const yearBE = Number(years);
    const yearAD = yearBE - 543;

    const Thmonths = yearAD >= 2026
        ? [
            { id: 10, year: yearAD - 1, month: `ต.ค ${yearBE - 1}` },
            { id: 11, year: yearAD - 1, month: `พ.ย ${yearBE - 1}` },
            { id: 12, year: yearAD - 1, month: `ธ.ค ${yearBE - 1}` },
            { id: 1, year: yearAD, month: "ม.ค" },
            { id: 2, year: yearAD, month: "ก.พ" },
            { id: 3, year: yearAD, month: "มี.ค" },
            { id: 4, year: yearAD, month: "เม.ย" },
            { id: 5, year: yearAD, month: "พ.ค" },
            { id: 6, year: yearAD, month: "มิ.ย" },
            { id: 7, year: yearAD, month: "ก.ค" },
            { id: 8, year: yearAD, month: "ส.ค" },
            { id: 9, year: yearAD, month: "ก.ย" },
        ]
        : [
            { id: 1, year: yearAD, month: "ม.ค" },
            { id: 2, year: yearAD, month: "ก.พ" },
            { id: 3, year: yearAD, month: "มี.ค" },
            { id: 4, year: yearAD, month: "เม.ย" },
            { id: 5, year: yearAD, month: "พ.ค" },
            { id: 6, year: yearAD, month: "มิ.ย" },
            { id: 7, year: yearAD, month: "ก.ค" },
            { id: 8, year: yearAD, month: "ส.ค" },
            { id: 9, year: yearAD, month: "ก.ย" },
            { id: 10, year: yearAD, month: "ต.ค" },
            { id: 11, year: yearAD, month: "พ.ย" },
            { id: 12, year: yearAD, month: "ธ.ค" },
        ];


    function getCalendarDaysByMonths(months) {
        return months.map(m => {
            return new Date(m.year, m.id, 0).getDate();
        });
    }

    const calendarDays = getCalendarDaysByMonths(Thmonths);

    const dataStudents = [
        { id: 1, sch: `SCH 1/${years}` },
        // { id: 2, sch: `SCH 2/${years}` },
        // { id: 3, sch: `SCH 3/${years}` }
    ];

    const hiddenItems = [
        'บุคลากร',
        'แม่บ้าน (ที่หน่วยงานจ้างเอง)',
        'รปภ.(ที่หน่วยงานจ้างเอง)',
        'ผู้เข้าพัก',
        'ผู้ใช้ห้องประชุม/สัมมนา',
        'SCH LEC',
        'SCH LAB',
        'SCH IS/THESIS',
        'NO, Stu THESIS',
        'SCH Project',
        'จำนวนผู้ป่วยใน',
        'จำนวนผู้ป่วยนอก',
        'จำนวน Man-hour ทั้งหมด'
    ];

    const getGroupInfo = (name) => {
        const trimmedName = name.trim();

        // กลุ่มพนักงาน
        if (['บุคลากร', 'แม่บ้าน (ที่หน่วยงานจ้างเอง)', 'รปภ.(ที่หน่วยงานจ้างเอง)'].includes(trimmedName)) {
            return { id: 1, name: 'จำนวนพนักงาน' };
        }
        // กลุ่มบริการห้องพัก
        else if (['ผู้เข้าพัก', 'ผู้ใช้ห้องประชุม/สัมมนา'].includes(trimmedName)) {
            return { id: 2, name: 'จำนวนผู้ใช้บริการห้องพัก/ห้องประชุม' };
        }
        // กลุ่มนักศึกษา
        else if (['SCH LEC', 'SCH LAB', 'SCH IS/THESIS', 'NO, Stu THESIS', 'SCH Project', 'จำนวน Man-hour ทั้งหมด'].includes(trimmedName)) {
            return { id: 3, name: 'ข้อมูลนักศึกษา' };
        }
        // กลุ่มบริการรพ.
        else if (['จำนวนผู้ป่วยใน', 'จำนวนผู้ป่วยนอก'].includes(trimmedName)) {
            return { id: 4, name: 'การเข้าใช้บริการ รพ.' };
        }
        // กรณีไม่ตรงกับกลุ่มใด
        return { id: 0, name: 'อื่นๆ' };
    };

    const fetchWorkingDays = async () => {
        try {
            const currentRes = await axios.get(
                `${config.urlApi}/working-days/${yearAD}`
            );

            const prevRes = yearAD >= 2026
                ? await axios.get(
                    `${config.urlApi}/working-days/${yearAD - 1}`
                )
                : { data: [] };

            const daysArray = Array(12).fill(0);

            // map ตาม Thmonths
            Thmonths.forEach((m, index) => {
                const source =
                    m.year === yearAD
                        ? currentRes.data
                        : prevRes.data;

                const found = source.find(d => d.month === m.id);
                daysArray[index] = found ? found.days : 0;
            });

            setWorkingDays(daysArray);

        } catch (err) {
            console.error(err);
        }
    };

    const fetchDataApi = useCallback(async () => {
        try {
            const usePrevious = yearAD >= 2026;

            const currentRes = await axios.get(
                `${config.urlApi}/scope/datasocpe/${id}`
            );

            const previousRes = usePrevious
                ? await axios.get(
                    `${config.urlApi}/scope/previous-data/${fac_id}/${yearAD - 1}`
                )
                : { data: [] };

            const currentData = currentRes?.data;
            const previousData = previousRes?.data ?? [];

            const mergedData = currentData.map(scope => {
                const prevScope = previousData.find(p => p.id === scope.id);

                return {
                    ...scope,
                    headcategories: scope.headcategories
                        .sort((a, b) => a.id - b.id)
                        .map(head => {
                            const prevHead = prevScope?.headcategories.find(
                                h => h.id === head.id
                            );

                            return {
                                ...head,
                                data_scopes: [
                                    ...(prevHead?.data_scopes ?? []),
                                    ...head.data_scopes
                                ]
                                .sort((a, b) => {
                                    const nameCompare = (a.name ?? '').localeCompare(b.name ?? '');
                                    if (nameCompare !== 0) return nameCompare;

                                    if (a.years !== b.years) return a.years - b.years;

                                    if (yearAD >= 2026) {
                                        return fiscalMonthOrder(a.month) - fiscalMonthOrder(b.month);
                                    }

                                    return a.month - b.month;
                                })
                            };
                        })
                };
            });

            const filterData = getFilteredData(mergedData);
            const result = groupData(filterData);

            setGroupedData(result);
        } catch (error) {
            console.error(error)
        }
    }, [id, fac_id, years]);

    const getFilteredData = (data) => {
         const result = [];
        const specialFac = ['MH2003', 'SD3003', 'SD3004'];
        const showData = [
            'บุคลากร', 'แม่บ้าน (ที่หน่วยงานจ้างเอง)', 'รปภ.(ที่หน่วยงานจ้างเอง)',
            'ผู้เข้าพัก', 'ผู้ใช้ห้องประชุม/สัมมนา', 'SCH LEC', 'SCH LAB',
            'SCH IS/THESIS', 'NO, Stu THESIS', 'SCH Project', 'จำนวน Man-hour ทั้งหมด'
        ];

        const selectedList = specialFac.includes(fac_id) ? hiddenItems : showData;

        data.forEach((activity) => {
            activity.headcategories.forEach((headCategory) => {
                if (headCategory.id === 6) {
                    result.push(...headCategory.data_scopes.filter(data_scope =>
                        selectedList.includes(data_scope.name.trim())
                    ));
                }
            })
        })
        return result;
    }

    const groupData = (data) => {
        const grouped = {};

        data.forEach((item) => {
            const { id, name: groupName } = getGroupInfo(item.name);
            if (!grouped[id]) {
                grouped[id] = {
                    id,
                    name: groupName,
                    items: []
                };
            }

            // จัดกลุ่มตามชื่อใน items
            if (!grouped[id].items[item.name]) {
                grouped[id].items[item.name] = [];
            }

            // grouped[id].items.push(item);
            grouped[id].items[item.name].push(item);
        });

        return Object.values(grouped).map(group => ({
            ...group,
            items: Object.entries(group.items).map(([name, items]) => ({
                name,
                items: items.sort(sortByYearMonth)
            }))
        }));
    };


    // ฟังก์ชันคำนวณ BOD
    const calculateBOD = (manHour) => {
        return ((manHour * 1.67) / 1000).toFixed(2);
    };

    const calculateManHour = (type, monthId, index) => {
        const month = monthId;
        const sem = monthId;

        switch (type) {
            case "staff": {
                const staff = parseFloat(inputValues[`บุคลากร-${month}`]) || 0;
                const maids = parseFloat(inputValues[`แม่บ้าน (ที่หน่วยงานจ้างเอง)-${month}`]) || 0;
                const security = parseFloat(inputValues[`รปภ.(ที่หน่วยงานจ้างเอง)-${month}`]) || 0;

                return (
                    staff * 9 * workingDays[index] +
                    maids * 9 * workingDays[index] +
                    security * 12 * calendarDays[index]
                );
            }
            case "guest": {
                const guests = parseFloat(inputValues[`ผู้เข้าพัก-${month}`]) || 0;
                const meeting = parseFloat(inputValues[`ผู้ใช้ห้องประชุม/สัมมนา-${month}`]) || 0;

                return (
                    guests * 12 * calendarDays[index] +
                    meeting * 9
                );
            }
            case "student": {
                const manHour = parseFloat(inputValues[`จำนวน Man-hour ทั้งหมด-${sem}`])
                return manHour;
            }
            case "hospital": {
                const inpatients = parseFloat(inputValues[`จำนวนผู้ป่วยใน-${month}`]) || 0;
                const outpatients = parseFloat(inputValues[`จำนวนผู้ป่วยนอก-${month}`]) || 0;

                return (
                    inpatients * 24 +
                    outpatients * 3
                )
            }

            default:
                return 0;
        }
    };

    // คำนวณค่าเฉลี่ย:
    const getAverage = (itemName) => {
        const values = Object.entries(inputValues)
            .filter(([key]) => key.startsWith(`${itemName}-`))
            .map(([, val]) => parseFloat(val))
            .filter(val => !isNaN(val) && val !== 0);

        return values.length
            ? (values.reduce((a, b) => a + b, 0) / values.length).toFixed(2)
            : "0.00";
    };

    const getSum = (itemName) => {
        const values = Object.entries(inputValues)
            .filter(([key]) => key.startsWith(`${itemName}-`))
            .map(([, val]) => parseFloat(val))
            .filter(val => !isNaN(val));

        return values.length
            ? values.reduce((a, b) => a + b, 0).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
            : "0.00";
    };

    const handleQuantityChange = (e, quantityDataId, inputKey) => {
        let inputValue = e.target.value;
        const quantityDataQuantity = inputValue.toString().replace(/,/g, '');

        setInputValues(prev => ({
            ...prev,
            [inputKey]: quantityDataQuantity
        }));

        handlerSaveData(quantityDataId, quantityDataQuantity);
    };

    const handlerSaveData = async (quantityDataId, quantityDataQuantity) => {
        if (!quantityDataQuantity || isNaN(quantityDataQuantity)) {
            return;
        }

        try {
            const data = {
                id: quantityDataId,
                quantity: quantityDataQuantity,
            };
            await axios.put(`${config.urlApi}/scope/updateQuantity/${id}`, data);
            fetchDataApi();
        } catch (e) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: e.message,
            });
        }
    };

    useEffect(() => {
        fetchDataApi();
    }, [fetchDataApi]);

    useEffect(() => {
        setIsDisabled(!isQuarterlyFillDate(years));
    }, [years]);

    useEffect(() => {
        fetchWorkingDays();
    }, []);

    useEffect(() => {
        if (groupedData.length === 0 || Object.keys(inputValues).length > 0) return;

        setInputValues(prev => {
            const newValues = { ...prev };

            groupedData.forEach(group => {
                group.items.forEach(item => {
                    item.items.forEach(data => {
                        if (!data.name || !data.month) return;

                        const key = `${data.name}-${data.month}`;

                        if (!(key in newValues)) {
                            newValues[key] = data.quantity ?? "";
                        }
                    });
                });
            });

            return newValues;
        });
    }, [groupedData]);

    useEffect(() => {
        if (!inputValues || Object.keys(inputValues).length === 0) return;

        const getTotalManHour = (monthIndex) => {
            const monthId = Thmonths[monthIndex].id;
            const types = ["staff", "guest", "hospital"];
            return types.reduce((sum, type) => {
                const val = calculateManHour(type, monthId, monthIndex);
                return sum + (Number(val) || 0);
            }, 0);
        };

        const BODByMonth = Thmonths.map((m, i) => {
            const result = calculateBOD(getTotalManHour(i));
            return parseFloat(result || 0).toFixed(2);
        });

        const BODStudent = calculateBOD(calculateManHour("student", 0) || 0);
        const dataBOD = { BODByMonth, BODStudent }
        
        onSendData(dataBOD);
    }, [inputValues]);

    return (
        <>
            <div className="card mb-4">
                <div className="card-header">
                    <span className="fs-5">การคำนวณ Septic tank</span>
                </div>
                <div className="card-body">
                    <div className="table-responsive">
                        <table className="table table-striped">
                            <thead>
                                <tr className="text-center">
                                    <th rowSpan="2">รายการ</th>
                                    <th rowSpan="2">หน่วย</th>
                                    <th colSpan="12">เดือน</th>
                                    <th rowSpan="2">Average/ <br/>Total</th>
                                </tr>
                                <tr className="text-center">
                                    {Thmonths.map((month) => (
                                        <th key={month.id}>{month.month}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {groupedData.filter(group => group.id !== 3).map((group) => (
                                    <React.Fragment key={group.id}>
                                        <tr>
                                            <td colSpan="15" className="bg-light fw-medium fs-5">
                                                {group.name}
                                            </td>
                                        </tr>
                                        {group.items.map((item) =>
                                            item.items.map((data, dataIndex) => {
                                                const isFirstRow = dataIndex === 0 ||
                                                    item.items[dataIndex - 1]?.name?.trim() !==
                                                    data?.name?.trim()
                                                    ;
                                                if (!isFirstRow) return null;

                                                return (
                                                    <tr key={`${data.name}-${dataIndex}`}>
                                                        <td>{data.name}</td>
                                                        <td>{data.lci}</td>

                                                        {Thmonths.map((Thmonth, index) => {
                                                            const inputKey = `${data.name}-${Thmonth.id}`;

                                                            const quantityData = item.items.find((it) =>
                                                                it.month === Thmonth.id &&
                                                                it.name === data.name
                                                            );
                                                            return (
                                                                <td key={`${data.name}-${index}`}>
                                                                    <NumericFormat
                                                                        key={inputKey}
                                                                        value={inputValues[inputKey] ?? ""}
                                                                        className="form-control"
                                                                        style={{
                                                                            borderRadius: "10px",
                                                                            border: "1px solid gray",
                                                                            width: "90px",
                                                                            padding: "5px",
                                                                        }}
                                                                        onFocus={(e) => {
                                                                            e.target.style.backgroundColor = "#DBF1C0";
                                                                        }}
                                                                        thousandSeparator={true}
                                                                        allowNegative={false}
                                                                        onValueChange={(values) => 
                                                                            handleQuantityChange(
                                                                                { target: { value: values.value } }, 
                                                                                quantityData.id, 
                                                                                inputKey
                                                                            )
                                                                        }
                                                                        disabled={isDisabled}
                                                                    />
                                                                </td>
                                                            )
                                                        })}
                                                        <td>
                                                            {
                                                                group.id === 1 || group.id === 2 ? getAverage(data.name) : getSum(data.name)
                                                            }
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        )}
                                        <tr>
                                            <td>จำนวน Man-hour ทั้งหมด</td>
                                            <td>Man-hour</td>
                                            {Thmonths.map((m, i) => {
                                                let manHour = 0;

                                                if (group.id === 1) {
                                                    manHour = calculateManHour("staff", m.id, i);

                                                } else if (group.id === 2) {
                                                    manHour = calculateManHour("guest", m.id, i);
                                                } else if (group.id === 4) {
                                                    manHour = calculateManHour("hospital", m.id, i);
                                                }

                                                return (
                                                    <td key={`manhour-${group.id}-${i}`}>
                                                        {manHour.toLocaleString()}
                                                    </td>
                                                );
                                            })}
                                            <td>
                                                {Thmonths.reduce((total, m, i) => {
                                                        let manHour = 0;

                                                        if (group.id === 1) {
                                                            manHour = calculateManHour("staff", m.id, i);
                                                        } else if (group.id === 2) {
                                                            manHour = calculateManHour("guest", m.id, i);
                                                        } else if (group.id === 4) {
                                                            manHour = calculateManHour("hospital", m.id, i);
                                                        }

                                                        return total + manHour;
                                                    }, 0).toLocaleString(undefined, {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                            </td>
                                        </tr>
                                        {/* ปริมาณ BOD ที่เข้าสู่ระบบ Septic */}
                                        <tr className="bg-light fw-bold">
                                            <td>ปริมาณ BOD ที่เข้าสู่ระบบ Septic</td>
                                            <td>kg</td>
                                            {Thmonths.map((m, i) => {
                                                let BOD = 0;

                                                if (group.id === 1) {
                                                    BOD = calculateBOD(calculateManHour("staff", m.id, i));
                                                } else if (group.id === 2) {
                                                    BOD = calculateBOD(calculateManHour("guest", m.id, i));
                                                }  else if (group.id === 4) {
                                                    BOD = calculateBOD(calculateManHour("hospital", m.id, i));
                                                }

                                                return (
                                                    <td key={`bod-${group.id}-${i}`}>
                                                        {BOD}
                                                    </td>
                                                )
                                            })}
                                            <td>
                                                {Thmonths
                                                    .reduce(
                                                        (total, m, i) => {
                                                            let BOD = 0;

                                                            if (group.id === 1) {
                                                                BOD = calculateBOD(calculateManHour("staff", m.id, i));
                                                            } else if (group.id === 2) {
                                                                BOD = calculateBOD(calculateManHour("guest", m.id, i));
                                                            } else if (group.id === 4) {
                                                                BOD = calculateBOD(calculateManHour("hospital", m.id, i));
                                                            }
                                                            return total + Number(BOD);
                                                        }, 0
                                                    ).toFixed(2)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan="15" >
                                                <hr />
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="mt-3">
                        <h5>ข้อมูลนักศึกษา</h5>
                    </div>
                    <div>
                        <div className="table-responsive">

                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th rowSpan="3" colSpan="6">รายการ</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {groupedData.filter(group => group.id === 3).map((group) => (
                                        <React.Fragment key={group.id}>
                                            {group.items.map((item) =>
                                                item.items.map((data, dataIndex) => {
                                                    const isFirstRow = dataIndex === 0 ||
                                                        item.items[dataIndex - 1]?.name?.trim() !==
                                                        data?.name?.trim();

                                                    if (!isFirstRow) return null;

                                                    return (
                                                        <tr key={`${data.name}-${dataIndex}`}>
                                                            <td colSpan="3">{data.name}</td>

                                                            {dataStudents.map((ds, index) => {
                                                                const inputKey = `${data.name}-${ds.id}`;
                                                                const quantityData = item.items.find((it) =>
                                                                    it.month === ds.id &&
                                                                    it.name === data.name
                                                                );
                                                                return (
                                                                    <td key={`${data.name}-${index}`}>
                                                                        <NumericFormat
                                                                            key={inputKey}
                                                                            value={inputValues[inputKey] ?? ""}
                                                                            className="form-control text-end"
                                                                            disabled={true}
                                                                            thousandSeparator={true}
                                                                            allowNegative={false}
                                                                            onValueChange={(values) => 
                                                                                handleQuantityChange(
                                                                                    { target: { value: values.value } }, 
                                                                                    quantityData.id, 
                                                                                    inputKey
                                                                                )
                                                                            }
                                                                            onFocus={(e) => {
                                                                                e.target.style.backgroundColor = "#DBF1C0";
                                                                            }}
                                                                        />
                                                                    </td>
                                                                )
                                                            })}
                                                        </tr>
                                                    )
                                                })
                                            )}
                                            
                                            {/* ปริมาณ BOD ที่เข้าสู่ระบบ Septic */}
                                            <tr className="bg-light fw-bold">
                                                <td colSpan="3">ปริมาณ BOD ที่เข้าสู่ระบบ Septic (kg)</td>
                                                {Array.from({ length: 1 }).map((_, i) => {
                                                    let BOD = 0;

                                                    if (group.id === 3 && dataStudents?.length > 0) {
                                                        BOD = calculateBOD(calculateManHour("student", dataStudents[0].id));
                                                    }
                                                    return (
                                                        <td key={`bod-${group.id}-${i}`} className="text-end">
                                                            {BOD || 0}
                                                        </td>
                                                    )
                                                })}
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SepticTable;
